﻿import * as $modal from './_modal'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    textName: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $('.' + options.pageName + ' a').click(function (e) {
        $modal.load($(this).attr('data-link'), {}, false, true, true)
        e.preventDefault()
    })
}
